'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

var _interopRequireWildcard = require('babel-runtime/helpers/interop-require-wildcard')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _componentsComponent = require('../../components/Component');

var _componentsComponent2 = _interopRequireDefault(_componentsComponent);

var _dbinfo = require('../../dbinfo');

var _dbinfo2 = _interopRequireDefault(_dbinfo);

var _constants = require('../../constants');

var Constants = _interopRequireWildcard(_constants);

var _componentsToolbar = require('../../components/Toolbar');

var _componentsToolbar2 = _interopRequireDefault(_componentsToolbar);

var _reactBootstrap = require('react-bootstrap');

var _reactisForms = require('reactis-forms');

var _reactisInputs = require('reactis-inputs');

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reactisModal = require('reactis-modal');

var _componentsFormDB = require('../../components/FormDB');

var _componentsFormDB2 = _interopRequireDefault(_componentsFormDB);

var _reactisLoader = require('reactis-loader');

var _componentsActionButton = require('../../components/ActionButton');

var _componentsActionButton2 = _interopRequireDefault(_componentsActionButton);

var _componentsSaveButton = require('../../components/SaveButton');

var _componentsSaveButton2 = _interopRequireDefault(_componentsSaveButton);

var _components = {
	_$Form: {
		displayName: 'Form'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var Form = (function (_FormDB) {
	_inherits(Form, _FormDB);

	function Form(props, context) {
		_classCallCheck(this, _Form);

		_FormDB.call(this, props, context);

		this.api = {
			fetch: 'trigger.fetch',
			save: 'trigger.save',
			remove: 'trigger.delete'
		};

		this.changeEvent = 'trigger.change';

		this.messages = {
			remove: 'Opravdu si přejete trigger odstranit?',
			notfound: 'Trigger nenalezen!'
		};

		this.schema = {
			title: {
				'class': _reactisInputs.TextInput,
				label: 'Název',
				autoFocus: !props.id,
				rules: {
					presence: { message: 'Název je povinná položka!' }
				}
			},
			active: {
				'class': _reactisInputs.Checkbox,
				label: 'Aktivní',
				value: true
			},

			metric: {
				'class': _reactisInputs.Select,
				label: 'Metrika',
				options: _dbinfo2['default'].Metric.asArray(),
				rules: {
					presence: { message: 'Metrika je povinná položka!' }
				}
			},

			condition: {
				'class': _reactisInputs.Select,
				label: 'Podmínka',
				options: _dbinfo2['default'].Condition.asArray(),
				clearable: false,
				value: 1,
				style: { width: 100, display: 'inline-table' }
			},

			value: {
				'class': _reactisInputs.TextInput,
				label: 'Hodnota',
				style: { width: 60, display: 'inline-table' }
			},

			alert_email: {
				'class': _reactisInputs.TextInput,
				label: 'E-mail'
			},

			alert_pushover: {
				'class': _reactisInputs.TextInput,
				label: 'Pushover'
			}
		};
		this.form = new _reactisForms.FormManager(this.schema);
	}

	Form.prototype.componentDidMount = function componentDidMount() {
		var _this = this;

		this.form.on('change', function (key, value) {
			if (key == 'title') {
				_this.title = value;
			}
			_this.changed = true;
		});
		_FormDB.prototype.componentDidMount.call(this);
	};

	Form.prototype.updateTab = function updateTab(data) {
		this.props.updateTab({ title: data.title });
	};

	Form.prototype.render = function render() {
		var _this2 = this;

		var loading = !!(this.props.form && this.props.form.get('loading'));

		var canEdit = true || this.user.isAllowed('user', 'update');
		var saveButton = _react2['default'].createElement(_componentsSaveButton2['default'], {
			disabled: !canEdit,
			loading: !!(this.props.form && this.props.form.get('saving')),
			onClick: function () {
				return _this2.save();
			}
		});

		var btns = _react2['default'].createElement(
			_reactBootstrap.ButtonToolbar,
			null,
			saveButton,
			this.props.id > 0 && _react2['default'].createElement(
				_componentsActionButton2['default'],
				{ disabled: !canEdit, bsStyle: 'danger', icon: 'fa fa-trash-o', onClick: function () {
						return _this2.remove();
					} },
				'Odstranit'
			)
		);

		return _react2['default'].createElement(
			'div',
			{ style: { position: 'relative' } },
			_react2['default'].createElement(_reactisLoader.Loader, { visible: !!(this.props.form && this.props.form.get('loading')) }),
			_react2['default'].createElement(
				_reactisForms.RxForm,
				{ ref: 'form', form: this.form, id: 'tab_' + this.props.tabid },
				_react2['default'].createElement(_componentsToolbar2['default'], { title: 'Trigger', buttons: btns }),
				_react2['default'].createElement(
					'div',
					{ className: 'row' },
					_react2['default'].createElement(
						'div',
						{ className: 'col-md-6' },
						_react2['default'].createElement(
							'table',
							{ className: 'form' },
							_react2['default'].createElement(
								'tbody',
								null,
								_react2['default'].createElement(_reactisForms.FormRow, { name: 'title', labelWidth: '135' }),
								_react2['default'].createElement(_reactisForms.FormRow, { name: 'active' }),
								_react2['default'].createElement(_reactisForms.FormRow, { name: 'metric' }),
								_react2['default'].createElement(
									_reactisForms.FormRow,
									{ label: 'Podmínka' },
									_react2['default'].createElement(
										'table',
										{ className: 'nopadding' },
										_react2['default'].createElement(
											'tbody',
											null,
											_react2['default'].createElement(
												'tr',
												null,
												_react2['default'].createElement(
													'td',
													null,
													_react2['default'].createElement(_reactisForms.FormField, { name: 'condition' })
												),
												_react2['default'].createElement(
													'td',
													null,
													_react2['default'].createElement(_reactisForms.FormField, { name: 'value' })
												)
											)
										)
									)
								),
								_react2['default'].createElement(
									'tr',
									{ className: 'divider' },
									_react2['default'].createElement(
										'td',
										{ colSpan: '2' },
										_react2['default'].createElement(
											'h6',
											null,
											'Oznámení'
										)
									)
								),
								_react2['default'].createElement(_reactisForms.FormRow, { name: 'alert_email' }),
								_react2['default'].createElement(_reactisForms.FormRow, { name: 'alert_pushover' }),
								_react2['default'].createElement(
									_reactisForms.FormRow,
									{ className: 'buttons' },
									saveButton
								)
							)
						)
					)
				)
			)
		);
	};

	var _Form = Form;
	Form = _wrapComponent('_$Form')(Form) || Form;
	Form = _reactRedux.connect(function (state, props) {
		return {
			form: state.forms.get('tab_' + props.tabid)
		};
	}, function (dispatch) {
		return { actions: _redux.bindActionCreators(_reactisForms.actions, dispatch) };
	}, null, { withRef: true })(Form) || Form;
	return Form;
})(_componentsFormDB2['default']);

exports['default'] = Form;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Trigger/Form.js
 ** module id = 973
 ** module chunks = 2
 **/